import type { FaireThemeEntity } from "../../entity_types/theme";

export const vibrant_tropical_refreshments: FaireThemeEntity = {
  token: "vibrant-tropical-refreshments",
  type: "theme",
  name: "Vibrant Tropical Refreshments",
  description: "Bright, fruit-forward snacks and drinks to energize your displays. These colorful items are excellent impulse buys for a boutique with a bold, playful aesthetic.",
  teaser: "Shiva's Gift Shop shows a clear interest in vibrant and 'trippy' art prints and novelty gifts, making these exotic flavors and fun shapes a great match for your store's vibe.",
  detail: "The payload includes the Arizona Dragonfruit Mango fusion and the tangy Haribo sour penne gummies, both of which provide a colorful and exotic snacking experience.",
  bgColor: "#B0C4D4",
  tileBgColor: "#39676b",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_ja7stvpa9r",
    "p_b5w3vswhz2",
    "p_6whc3pkpzz",
    "p_m9f4gfzhwe",
    "p_bzvwf3fa6z",
    "p_7bnmjdrvwe",
    "p_cnkq5xfgxm",
    "p_8pefnn93zy",
    "p_xtuf37qb5k",
    "p_9p3pbwyarb",
    "p_13tgn8tetl",
    "p_bzvoaigo2m",
    "p_kwdeqkfz38",
    "p_bnjkzqmazs",
    "p_yxguhauefg",
    "p_zy6r9mczyx",
    "p_t3avksrwvm",
    "p_9tg9byww7r",
    "p_66rmrxdmj8",
    "p_sdxunwu3z5",
    "p_ndbuw94d2j",
    "p_kuhks4uzbv",
    "p_kuyzbp7eek",
    "p_wck748zva9",
    "p_mwu7h8446v",
    "p_t6xa8apzh4",
    "p_h8drcsm45b",
    "p_8qhvghbf8t",
    "p_xjrqhrrw77",
    "p_5yb9875rgu",
    "p_w4cqrmh3an",
    "p_23awqh3pqs",
    "p_zvqfh55qrr",
    "p_4qubbw3smy",
    "p_hruxhwpetx",
    "p_afnqacsc7v",
    "p_3zrzmjrcah",
    "p_xt3ab5wvqp",
    "p_s7tkgxwstz",
    "p_kb774ksdrr",
    "p_rhx4kpqxfq",
    "p_gww4gxsqxu",
    "p_eqwjmjvuqm",
    "p_f3yxgc29pu",
    "p_uwt2zq4an7",
    "p_9ptsuuoarf",
    "p_y36uve6kv5",
    "p_43ydcutjve",
    "p_ajyr64fg3b",
    "p_natp5ubn35",
    "p_n83442wbwf",
    "p_que8rz3c2r",
    "p_m2dr4d3xa4",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
